module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/ring.26f8c6cf.jpg";